import { Input } from '@domgen/base-design-system-2.0/atoms/Input';
import { CircleCheck } from '../../../assets/icons/CircleCheck';
import { usProvinces } from '../constants/usProvinces';
import { FormChangeEvent } from '../../../hooks/useFormValidation';
import { FormKey } from '../../../enums/formKey';
import { StepKey } from '../../../enums/stepKey';
import { Select } from '@domgen/base-design-system-2.0/atoms/Select';
import { ApplianceFormData } from '../../../models/form/appliance';
import { AutoComplete } from '@domgen/shared/enums/autoComplete';

type ManualMerchandiseLocationFormProps = {
  formValues: Partial<ApplianceFormData[StepKey.PERSONAL_DETAILS]>;
  errors: Record<string, string>;
  handleChange: (e: FormChangeEvent) => string | void;
  onBlur: (e: FormChangeEvent) => string | void;
};

export const ManualMerchandiseLocationForm = ({
  formValues,
  errors,
  handleChange,
  onBlur,
}: ManualMerchandiseLocationFormProps) => {
  return (
    <>
      <div className="col-span-8">
        <Input
          value={(formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_1] as string) ?? ''}
          label="Address line 1"
          placeholder="Enter address line 1"
          name={FormKey.MERCHANDISE_ADDRESS_LINE_1}
          onChange={handleChange}
          onBlur={onBlur}
          rightIcon={
            formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_1] &&
            !errors?.[FormKey.MERCHANDISE_ADDRESS_LINE_1] ? (
              <CircleCheck />
            ) : undefined
          }
          hasError={errors?.[FormKey.MERCHANDISE_ADDRESS_LINE_1]}
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_1] !== '' &&
            !errors?.[FormKey.MERCHANDISE_ADDRESS_LINE_1]
          }
          autoComplete={AutoComplete.OFF}
        />
      </div>
      <div className="col-span-8">
        <Input
          value={(formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_2] as string) ?? ''}
          label="Address line 2 (Optional)"
          placeholder="Address line 2 (apartment, suite, etc.)"
          name={FormKey.MERCHANDISE_ADDRESS_LINE_2}
          onChange={handleChange}
          onBlur={onBlur}
          rightIcon={
            formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_2] &&
            !errors?.[FormKey.MERCHANDISE_ADDRESS_LINE_2] ? (
              <CircleCheck />
            ) : undefined
          }
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_ADDRESS_LINE_2] !== '' &&
            !errors?.[FormKey.MERCHANDISE_ADDRESS_LINE_2]
          }
          autoComplete={AutoComplete.OFF}
        />
      </div>
      <div className="col-span-8">
        <Select
          label="State"
          placeholder="Select a state"
          name={FormKey.MERCHANDISE_STATE_CODE}
          id={FormKey.MERCHANDISE_STATE_CODE}
          hasError={errors[FormKey.MERCHANDISE_STATE_CODE]}
          options={usProvinces}
          value={(formValues?.[FormKey.MERCHANDISE_STATE_CODE] as string) ?? ''}
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_STATE_CODE] !== '' &&
            !errors[FormKey.MERCHANDISE_STATE_CODE]
          }
          onChange={(value: string) =>
            handleChange({
              target: { name: FormKey.MERCHANDISE_STATE_CODE, value },
            } as FormChangeEvent)
          }
          onBlur={(value: string) =>
            onBlur({
              target: {
                name: FormKey.MERCHANDISE_STATE_CODE,
                value,
              },
            } as FormChangeEvent)
          }
          maxHeight={320}
          autoComplete={AutoComplete.OFF}
        />
      </div>
      <div className="col-span-8 md:col-span-4">
        <Input
          value={(formValues?.[FormKey.MERCHANDISE_CITY] as string) ?? ''}
          label="City"
          placeholder="Enter a city"
          name={FormKey.MERCHANDISE_CITY}
          onChange={handleChange}
          onBlur={onBlur}
          rightIcon={
            formValues?.[FormKey.MERCHANDISE_CITY] && !errors?.[FormKey.MERCHANDISE_CITY] ? (
              <CircleCheck />
            ) : undefined
          }
          hasError={errors?.[FormKey.MERCHANDISE_CITY]}
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_CITY] !== '' && !errors?.[FormKey.MERCHANDISE_CITY]
          }
          autoComplete={AutoComplete.OFF}
        />
      </div>
      <div className="col-span-8 md:col-span-4">
        <Input
          value={(formValues?.[FormKey.MERCHANDISE_POSTAL_CODE] as string) ?? ''}
          label="Zip code"
          placeholder="Enter a zip code"
          name={FormKey.MERCHANDISE_POSTAL_CODE}
          onChange={handleChange}
          onBlur={onBlur}
          rightIcon={
            formValues?.[FormKey.MERCHANDISE_POSTAL_CODE] &&
            !errors?.[FormKey.MERCHANDISE_POSTAL_CODE] ? (
              <CircleCheck />
            ) : undefined
          }
          hasError={errors?.[FormKey.MERCHANDISE_POSTAL_CODE]}
          hasSuccess={
            formValues?.[FormKey.MERCHANDISE_POSTAL_CODE] !== '' &&
            !errors?.[FormKey.MERCHANDISE_POSTAL_CODE]
          }
          autoComplete={AutoComplete.OFF}
        />
      </div>
    </>
  );
};
